import { PaletteMode } from "@mui/material";
import { IFinanceProductResults, IVehicleIdentity } from "./codeweavers.model";

export interface IFinanceCalculatorFormState
{
    showHP: boolean;
    showPCP: boolean;
    vehicleBased: boolean;
    knownRegNo: boolean;
    apr: number;
    cashPrice?: number;
    deposit: number;
    currentMileage: number;
    annualMileage: number;
    term: number;
    regNo: string;
    identity?: IVehicleIdentity;
    derivative?: string;
    /*
    vehicle?: string;
    vehicleDesc?: string;
    vehicleYear?: string;
    */
    creditRating: string;
}

export const defaultFormState: IFinanceCalculatorFormState = {
    showHP: true,
    showPCP: true,
    vehicleBased: true,
    knownRegNo: true,
    apr: 0,
    cashPrice: undefined,
    deposit: 0,
    currentMileage: 0,
    annualMileage: 8000,
    term: 36,
    regNo: "",
    identity: undefined,
    derivative: undefined,
    /*
    vehicle: undefined,
    vehicleDesc: undefined,
    vehicleYear: undefined,
    */
    creditRating: "good"
  };

export interface IFinanceCalculatorState
{
    mode: PaletteMode;
    submitted: boolean;
    formdata: IFinanceCalculatorFormState;
    errordata?: IFinanceProductResults[];
    resultsdata?: IFinanceProductResults[];
    selectedIndex: number;
    contacting: boolean;
    contactsubmitted: boolean;
    contactdata: IContactData | undefined;
}
 
export interface IProductMinValue
{
    minValue: number;
    minIndex: number;
}

export interface IProductMinValueSet
{
    hp: IProductMinValue;
    pcp: IProductMinValue;
}

export interface IContactData
{
    contactName: string;
    emailAddress: string;
    telNo: string;
    notes: string;
    ok2contact: boolean;
    emailSpecifics: boolean;
}

export interface IFinanceCalculatorContactRequest
{
    formdata: IFinanceCalculatorFormState;
    results?: IFinanceProductResults;
    contactdata: IContactData;
}
